//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadFile } from '@/api/yuangongquan'
import timeimg from '@/assets/yiliaohuzhu/time.png'
import tips1 from '@/assets/yiliaohuzhu/directions1.png'
import tips2 from '@/assets/yiliaohuzhu/directions2.png'
import axios from 'axios'
import { Form, Field, Cell, Button, Popup, Picker, DatetimePicker, Uploader, Col, Row, ImagePreview, Toast } from 'vant'
import { getUserInfo, getcheckList, getcost, addList, checkHB, checkCB, zycost } from '@/api/yiliaohuzhu'
export default {
  name: 'createList',
  components: {
    vanForm: Form,
    vanField: Field,
    vanButton: Button,
    vanCell: Cell,
    vanPopup: Popup,
    vanPicker: Picker,
    vanDatetimePicker: DatetimePicker,
    vanUploader: Uploader,
    vanCol: Col,
    vanRow: Row
  },
  props: {},
  data () {
    return {
      timeimg: timeimg,
      name: '', // 姓名
      sextext: '', // 性别
      sex: '',
      age: '', // 年龄
      phoneNumber: '', // 手机号码
      idCard: '', // 身份证
      city: '', // 地市
      cityid: '',
      county: '', // 区县
      countyid: '',
      medicalTypetext: '', // 申请补助类别
      medicalType: '3',
      bzvaluetext: '', // 病种名称
      bzvalue: '', // 病种名称
      bzname: '', // 所患病名
      stpaynf: '', // 起始交费年份
      outtime: '', // 出院时间
      sftypetext: '', // 身份性质
      sftype: '', // 身份性质
      company: '', // 单位
      comtypetext: '', // 单位类别
      comtype: '', // 单位类别
      payee: '', // 收款人
      cost: '', // 补助金额
      banknum: '', // 收款银行卡号
      appreason: '', // 申请补助理由
      pathid: [], // 费用结算单
      pathid1: [], // 发票
      pathid2: [], // 出院记录
      pathid3: [], // 病理检查报告单
      showsex: false,
      showcity: false,
      showcounty: false,
      showtype: false,
      showbz: false,
      shownf: false,
      showcy: false,
      showsf: false,
      showdw: false,
      sexList: [{ text: '男', value: 1 }, { text: '女', value: 2 }],
      cityList: [],
      countyList: [{ key: '', value: '请选择' }],
      typeList: [{ text: '重病', value: 1 }, { text: '大病', value: 2 }],
      bzList: [],
      sfList: [{ text: '合同用工', value: 1 }, { text: '劳务派遣', value: 2 }, { text: '退休', value: 3 }, { text: '退养', value: 4 }, { text: '其他人员', value: 5 }],
      dwList: [{ text: '邮政', value: 1 }, { text: '中邮保险', value: 2 }, { text: '速递', value: 3 }],
      checkitem: {
        isname: true,
        issex: true,
        isage: true,
        isphoneNumber: true,
        isidCard: true,
        iscity: false,
        iscounty: false,
        ismedicalType: false,
        isbzvalue: false,
        isbzname: false,
        isstpaynf: true,
        isouttime: false,
        issftype: true,
        iscompany: true,
        iscomtype: true,
        ispayee: false,
        iscost: true,
        isbanknum: false,
        isappreason: false
      },
      imglist: [], // 费用结算单
      imglist1: [], // 发票
      imglist2: [], // 出院记录
      // imglist3: [],
      tips1: tips1, // 填写说明1
      tips2: tips2, // 填写说明2
      showot: false,
      tot: [], // 添加结算：费用总额
      zl: [], // 添加结算：自理费用
      zf: [], // 添加结算：自费费用
      tc: [], // 添加结算：统筹基金支付
      ot: [], // 添加结算：出院时间
      fyze: 0,
      zlfy: 0,
      zffy: 0,
      tcjjfy: 0,
      appcost: 0, // 补助基数
      activeindex: 1,
      ottime: '',
      appcosts: '', // 历年补助
      isHB: true,
      isCB: true
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  created () { },
  mounted () {
    this.getUser()
    this.getcitylist()
    // this.getbzlist()
    // this.getList()
  },
  methods: {
    onSubmit (values) {
      console.log('submit', values)
      if (this.appcost + eval(this.appcosts.join('+')) < 1000) {
        Toast('补助基数不能小于1000')
        return false
      } else if (this.isCB == false) {
        Toast('当年没参保')
        return false
      } else if (this.isHB == false) {
        Toast('此前已添加过住院补助申请，请在相同年度提交申请中添加住院记录')
        return false
      }
      // this.judgement()
      let formdata = values
      formdata.pathid = this.imglist.join(';')
      formdata.pathid1 = this.imglist1.join(';')
      formdata.pathid2 = this.imglist2.join(';')
      // formdata.pathid3 = this.imglist3.join(';')
      formdata.sex = this.sex
      // formdata.bzvalue = this.bzvalue
      formdata.cityid = this.cityid
      formdata.countyid = this.countyid
      formdata.comtype = this.comtype
      formdata.medicalType = this.medicalType
      formdata.sftype = this.sftype
      formdata.tot = this.tot.join(',')
      formdata.zl = this.zl.join(',')
      formdata.zf = this.zf.join(',')
      formdata.tc = this.tc.join(',')
      formdata.ot = this.ot.join(',')
      formdata.fyzes = (this.tot.join(',') || 0) + ','
      formdata.zlfys = (this.zl.join(',') || 0) + ','
      formdata.zffys = (this.zf.join(',') || 0) + ','
      formdata.tcjjfys = (this.tc.join(',') || 0) + ','
      formdata.ots = this.ot.join(',') + ','
      formdata.accountId = this.accountid
      console.log(formdata)
      addList(formdata).then(res => {
        if (res.success) {
          Toast('新增成功')
          this.$router.push({ name: 'yiliaohuzhuHome' })
        }
      })
    },
    getzycost () {
      zycost({
        idCard: this.idCard
      }).then(res => {
        this.appcosts = res.obj.appcosts
      })
    },
    addfy () {
      this.activeindex++
    },
    deletefy (index) {
      this.tot.splice(index, 1)
      this.zl.splice(index, 1)
      this.zf.splice(index, 1)
      this.tc.splice(index, 1)
      this.ot.splice(index, 1)
      this.activeindex--
      if (this.activeindex == 0) {
        this.fyze = 0
        this.zlfy = 0
        this.zffy = 0
        this.tcjjfy = 0
        this.appcost = 0
        this.cost = ''
      }
    },
    computefy () {
      if (this.activeindex == 0) {
        this.fyze = 0
        this.zlfy = 0
        this.zffy = 0
        this.tcjjfy = 0
        this.appcost = 0
        this.cost = ''
      } else {
        if (this.ot.length < this.activeindex) {
          Toast('请填写出院时间')
          return false
        } else if (this.isCB == false) {
          Toast('当年没参保')
          return false
        } else if (this.isHB == false) {
          Toast('此前已添加过住院补助申请，请在相同年度提交申请中添加住院记录')
          return false
        }
        this.fyze = (eval(this.tot.join('+')) || 0).toFixed(2)
        this.zlfy = (eval(this.zl.join('+')) || 0).toFixed(2)
        this.zffy = (eval(this.zf.join('+')) || 0).toFixed(2)
        this.tcjjfy = (eval(this.tc.join('+')) || 0).toFixed(2)
        this.appcost = (this.fyze - this.zlfy - this.zffy - this.tcjjfy).toFixed(2)
        this.checkchange()
      }
    },
    preview (index) {
      ImagePreview({
        images: [
          this.tips1,
          this.tips2
        ],
        startPosition: index
      })
    },
    checkchange () {
      if (this.ot[0] == '') {
        return
      }
      if (this.appcost == '') {
        return
      }
      if (this.stpaynf == '') {
        return
      }
      if (this.sftype == '') {
        return
      }
      getcost({
        medicalType: this.medicalType,
        outtime: this.ot[0],
        appcost: this.appcost,
        stpaynf: this.stpaynf,
        sftype: this.sftype,
        idCard: this.idCard
      }).then(data => {
        this.cost = data.obj.cost.toFixed(2)
      })
    },
    // 获取地市
    getcitylist () {
      axios.get('http://www.zjftu.org/youzheng/sysDd/FTU_WXCP_DEPARTNEW.action?plistvalue=1').then(res => {
        this.cityList = res.data
      })
    },
    // 获取区县
    getcounty (id) {
      if (id == '') {
        this.county = ''
        this.countyList = [{ key: '', value: '请选择' }]
      } else {
        axios.get('http://www.zjftu.org/youzheng/sysDd/FTU_WXCP_DEPARTNEW.action', {
          params: {
            plistvalue: id
          }
        }).then(res => {
          this.countyList = res.data
        })
      }
    },
    getbzlist () {
      axios.get('http://www.zjftu.org/youzheng/sysDd/FTU_MEDICAL_BZTYPE.action', {
        params: {
          plistvalue: 3
        }
      }).then(res => {
        this.bzList = res.data
      })
    },
    getUser () {
      getUserInfo({
        userid: this.userid
      }).then(res => {
        this.idCard = res.obj.idcard
        this.getList()
        this.getzycost()
      })
    },
    getList () {
      getcheckList({
        idCard: this.idCard
      }).then(data => {
        this.name = data.obj.name
        this.sextext = data.obj.sex === 1 ? '男' : '女'
        this.sex = data.obj.sex
        this.age = this.setage(this.idCard)
        this.phoneNumber = data.obj.phoneNumber
        this.stpaynf = data.obj.joinTime
        this.company = data.obj.unitName
        this.comtype = data.obj.unitCategory
        this.dwList.forEach(element => {
          if (data.obj.unitCategory == element.value) {
            this.comtypetext = element.text
          }
        })
        this.sftype = data.obj.employmentNature
        this.sfList.forEach(element => {
          if (data.obj.employmentNature == element.value) {
            this.sftypetext = element.text
          }
        })
      })
    },
    setage (identityCard) {
      var len = (identityCard + '').length
      if (len == 0) {
        return 0
      } else {
        if ((len != 15) && (len != 18))// 身份证号码只能为15位或18位其它不合法
        {
          return 0
        }
      }
      var strBirthday = ''
      if (len == 18)// 处理18位的身份证号码从号码中得到生日和性别代码
      {
        strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
      }
      if (len == 15) {
        strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
      }
      // 时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday)
      var nowDateTime = new Date()
      var age = nowDateTime.getFullYear() - birthDate.getFullYear()
      // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
    // 确认性别
    onConfirmsex (v) {
      this.sextext = v.text
      this.sex = v.value
      this.showsex = false
    },
    // 确认地市
    onConfirmcity (v) {
      this.cityid = v.key
      if (v.key != '') {
        this.city = v.value
      } else {
        this.city = ''
      }
      this.county = ''
      this.countyid = ''
      this.countyList = [{ key: '', value: '请选择' }]
      this.getcounty(v.key)
      this.showcity = false
    },
    // 确认区县
    onConfirmcounty (v) {
      if (v.key != '') {
        this.county = v.value
      }
      this.countyid = v.key
      this.showcounty = false
    },
    // onConfirmtype (v) {
    //   this.medicalTypetext = v.text
    //   this.medicalType = v.value
    //   this.getbzlist()
    //   this.showtype = false
    //   this.checkchange()
    // },
    // onConfirmbz (v) {
    //   if (v.key != '') {
    //     this.bzvaluetext = v.value
    //   }
    //   this.bzvalue = v.key
    //   this.showbz = false
    //   this.checkchange()
    // },
    // 确认起始交费年份
    onConfirmnf (time) {
      let date = new Date(time)
      this.stpaynf = date.getFullYear() + '-' + ((date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() <= 9 ? '0' + date.getDate() : date.getDate())
      this.shownf = false
      this.checkchange()
    },
    // onConfirmcy (time) {
    //   let date = new Date(time)
    //   this.outtime = date.getFullYear() + '-' + ((date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() <= 9 ? '0' + date.getDate() : date.getDate())
    //   this.showcy = false
    //   this.checkchange()
    // },
    // 确认出院时间
    onConfirmot (index) {
      let date = new Date(this.ottime)
      this.ot[index] = date.getFullYear() + '-' + ((date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() <= 9 ? '0' + date.getDate() : date.getDate())
      this.showot = false
      this.judgement(this.ot[index])
    },
    // 确认身份性质
    onConfirmsf (v) {
      this.sftype = v.value
      this.sftypetext = v.text
      this.showsf = false
      this.checkchange()
    },
    // 确认单位类别
    onConfirmdw (v) {
      this.comtype = v.value
      this.comtypetext = v.text
      this.showdw = false
    },
    // 格式化弹窗年月日
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    read0 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist.push(data.obj[0].id)
      })
    },
    delete0 (item, detail) {
      this.imglist.splice(detail.index, 1)
      return 1
    },
    read1 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist1.push(data.obj[0].id)
      })
    },
    delete1 (item, detail) {
      this.imglist1.splice(detail.index, 1)
      return 1
    },
    read2 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist2.push(data.obj[0].id)
      })
    },
    delete2 (item, detail) {
      this.imglist2.splice(detail.index, 1)
      return 1
    },
    // read3 (item) {
    //   let formData = new FormData()
    //   formData.append('file', item.file)
    //   uploadFile(formData).then(data => {
    //     this.imglist3.push(data.obj[0].id)
    //   })
    // },
    // delete3 (item, detail) {
    //   this.imglist3.splice(detail.index, 1)
    //   return 1
    // },
    // 判断填写的出院时间是否正确
    judgement (time) {
      checkCB({
        idCard: this.idCard,
        outtime: time
      }).then(res => {
        if (res.success) {
          this.isCB = true
          checkHB({
            idCard: this.idCard,
            outtime: time
          }).then(data => {
            if (data.success) {
              this.isHB = true
            }
          }).catch(e => {
            this.isHB = false
          })
        }
      }).catch(e => {
        this.isCB = false
      })
    }
  }
}
